const BrowseOnlyMixin = {

    data(){
        return {
            app: this.$root.$data.app,
        }
    },

    methods: {
        handleBrowseInteract(go_to_menu=false){
            this.$ons.notification.alert(
            'Please login to place an order.',
            {
                        title: 'Login to order',
                        buttonLabels: [
                            'Login',
                            'Continue browsing',
                        ]
                    }
                )
                .then(result => {
                    // Login
                    if (result == 0)
                        this.app.goodiesLogin()
                    // Otherwise go back if needed
                    else if (go_to_menu && this.outlet)
                        this.$router.replace({ name: 'Menu', params: { outlet_slug: this.outlet.slug } })
                })
        }
    }
}

export default BrowseOnlyMixin


// WEBPACK FOOTER //
// ./src/js/mixins/browse_only.js